/*
 * Comcast CONFIDENTIAL
 *
 * Copyright 2003 - 2017 Comcast Corporation
 * All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Comcast Corporation and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Comcast Corporation
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is unlawful and strictly forbidden unless prior written permission is obtained
 * from Comcast Corporation.
 */
import { DestinationsController } from './destinations-controller';
var dependencies = ['ngMaterial', 'comcast.common.authentication', 'comcast.common.communication', 'comcast.common.navigation', 'ngMessages', 'ui.router', 'comcast-addelivery-constants', 'comcast.common.notification', 'comcast.directives'];
var defaultName = angular.module('comcast.destinations', dependencies).config(['$stateProvider', 'addelivery.state.constants', function ($stateProvider, stateConstants) {
  $stateProvider.state('destinations', {
    url: '/destinations',
    views: {
      mainNav: stateConstants.mainNav,
      leftNav: stateConstants.leftNav,
      content: {
        template: require('./destinations-template.html'),
        controller: DestinationsController,
        controllerAs: 'vm'
      }
    },
    access: {
      requiresLogin: true,
      requiredPermissions: ['User'],
      permissionCheckType: 'AtLeastOne'
    }
  });
}]).name;
export { defaultName as default, dependencies };